// START IMPORTS
import { Box, LoadingReportCard } from '@ltvco/refresh-lib/theme';
// END IMPORTS

export function LoadingReports() {
  // START RENDER
  return (
    <Box mt={2.5}>
      <LoadingReportCard />
      <LoadingReportCard />
      <LoadingReportCard />
    </Box>
  );
  // END RENDER
}
